<template>
  <div class="warning-recordlist">
    <div class="top-title">诊断报告</div>
    <div
      style="padding-top: 8px"
      v-if="['m0', 'm1'].indexOf(this.userRole) > -1"
    >
      <redtaiTab @input="tabinput" :list="list" />
    </div>
    <!-- <Card dis-hover> -->
    <ul class="common-search li-margin">
      <li>
        <span>诊断报告名称: </span>
        <Input
          v-model="dataForm.name"
          name="name"
          @on-search="(e) => searchInput(e, 'name')"
          search
          placeholder="请输入"
        />
      </li>

      <li>
        <span>润滑点名称: </span>
        <Input
          v-model="dataForm.oilSiteName"
          @on-search="(e) => searchInput(e, 'oilSiteName')"
          search
          placeholder="请输入"
        />
      </li>
      <li>
        <span>设备名称: </span>
        <Input
          v-model="dataForm.deviceName"
          @on-search="(e) => searchInput(e, 'deviceName')"
          search
          placeholder="请输入"
        />
      </li>
      <li v-if="!(['c0', 'c1'].indexOf(this.userRole) > -1)">
        <span>客户名称: </span>
        <!-- <Select @on-clear="(e)=>nameclear(e,'customerName')" 
              v-model="dataForm.customerName" @on-change="(e)=>changeSel(e,'customerName')" :clearable="true" placeholder="全部">
              <OptionGroup :label="cus.letter" :key="cus.letter" v-for="cus in namelist">
                <Option :key="key2" :value="cus2" v-for="(cus2,key2) in cus.data">{{cus2}}</Option>
              </OptionGroup>
            </Select> -->
        <Input
          v-model="dataForm.customerName"
          @on-search="(e) => searchInput(e, 'customerName')"
          search
          placeholder="请输入"
        />
      </li>

      <li>
        <span>润滑点装置: </span>
        <Select
          v-model="dataForm.zhuangzhiId"
          @on-change="(e) => changeSel(e, 'zhuangzhiId', cityList)"
          :clearable="true"
          placeholder="全部"
        >
          <Option :key="type.id" :value="type.id" v-for="type in cityList">{{
            type.name
          }}</Option>
        </Select>
      </li>
      <li>
        <span>设备类型: </span>
        <Select
          v-model="dataForm.deviceTypeId"
          @on-change="(e) => changeSel(e, 'deviceTypeId')"
          placeholder="全部"
        >
          <OptionGroup
            :label="cus.value"
            :key="cus.id"
            v-for="cus in dataCenter.deviceType"
          >
            <Option
              :key="cus2.id"
              :value="cus2.id"
              v-for="cus2 in cus.children"
              >{{ cus2.value }}</Option
            >
          </OptionGroup>
        </Select>
      </li>
      <li v-if="!(['c0', 'c1'].indexOf(this.userRole) > -1)">
        <span>客户行业: </span>
        <Select
          v-model="dataForm.customerIndustryId"
          @on-change="(e) => changeSel(e, 'customerIndustryId')"
          placeholder="全部"
        >
          <OptionGroup
            :label="con.value"
            :key="con.id"
            v-for="con in dataCenter.consumerIndustry"
          >
            <Option
              :key="con2.id"
              :value="con2.id"
              v-for="con2 in con.children"
              >{{ con2.value }}</Option
            >
          </OptionGroup>
        </Select>
      </li>
      <li>
        <span>报告类型: </span>
        <Select
          v-model="dataForm.type"
          @on-change="(e) => changeSel(e, 'reportType')"
          placeholder="全部"
        >
          <Option :value="1">润滑点</Option>
          <Option :value="2">设备报告</Option>
          <Option :value="3">客户报告</Option>
        </Select>
      </li>

      <li class="dataPicker" v-if="pageInfo.state == 20">
        <span>发布时间: </span>
        <DatePicker
          :clearable="false"
          @on-change="(e) => changeDate(e, 'gmtCreate')"
          style="width: 180px"
          v-model="dataForm.gmtCreate"
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="请选择"
        ></DatePicker>
      </li>
      <!-- <li v-if="(['m0','m1'].indexOf(this.userRole)>-1)">
          <span>发布状态: </span>
          <Select v-model="dataForm.state" @on-change="(e)=>changeSel(e,'state',)" placeholder="全部">
            <Option value="10">未发布</Option>
            <Option value="20">已发布</Option>
          </Select>
        </li> -->

      <li v-if="tabName == '已发布'">
        <span>已读/未读: </span>
        <Select
          v-model="dataForm.readInfo"
          @on-change="(e) => changeSel(e, 'readInfo')"
          placeholder="全部"
        >
          <Option value="1">已读</Option>
          <Option value="0"> 未读</Option>
        </Select>
      </li>
      <li class="searchItem">
        <Button class="sels-item" @click="resetData">重置</Button>
      </li>
    </ul>

    <!-- selected -->
    <div class="common-selects selected-margin" v-if="selItems.length">
      <span class="tit">已选:</span>
      <span class="sel" v-for="(item, index) in selItems" :key="index"
        >{{ item.val }}
        <Icon @click="delSelItem(item, index)" type="md-close-circle" />
      </span>
    </div>

    <!-- v-if='dataLists.length' -->
    <div class="lists clearfix list-margin">
      <Button
        v-nohasPermi="['m3', 'm4']"
        @click="addOil"
        id="dig-addbtn"
        v-if="userRole.indexOf('m') >= 0"
        type="primary"
      >
        <Icon type="md-add" />新增诊断报告</Button
      >
      <!-- 列表 -->
      <div class="common-list table-margin">
        <Table
          class="equipmentTable"
          :columns="dataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <!-- 分页器 -->
      <div class="common-page fr" v-if="pageInfo.total">
        <Page
          show-total
          show-elevator
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.current"
          :page-size="pageInfo.size"
          @on-change="getLists"
          @on-page-size-change="changeSize"
        ></Page>
      </div>
    </div>
    <DiaMoudl
      :nvtodetl="nvtodetl1"
      :showDrawer="showDrawer"
      :closeDrawer="closeDrawer"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
      :dataCenter="dataCenter"
    />

    <!-- </Card> -->
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from "vuex";
import handleSelItem from "@/mixins/handleSelItem";
import moment from "moment";
import {
  equipmentTree,
  delpmentTree,
  oilSiteModelPublish,
  oilSiteModelread,
  diagnosticcancel,
} from "@/api/warning/diagnostic";
import DiaMoudl from "./components/diagnostic-drawer.vue";
import suceess from "@/assets/images/icon/green-success.png";
import water from "@/assets/images/icon/water.png";
import { ocmselect } from "@/api/business/rhlist";
import redtaiTab from "@/components/redtai-tab/index";
import { olitypelist } from "@/api/knowledge/device.js";
import { sockedDel, relatedInfo } from "@/api/business/rhlist";
export default {
  name: "warning-recordlist",
  mixins: [handleSelItem],
  components: {
    DiaMoudl,
    redtaiTab,
  },
  watch: {
    diagnosticindex() {
      this.getLists();
    },
  },
  computed: {
    //   bmaro() {
    //     let bo =  this.userRole == 'm1' || this.userRole == 'm1'
    //     return bo
    //   },
    ...mapState({
      dataCenter: (state) => state.dataCenter,
      diagnosticindex: (state) => state.diagnostic.diagnosticindex,
    }),
  },
  data() {
    return {
      cityList: [],
      list: ["未发布", "已发布"],
      tabName: "未发布",
      namelist: [],
      userRole: ls.get("userRole"),

      dataLists: [],
      selItems: [],
      dataForm: {},
      pageInfo: {
        size: 10,
        current: 1,
        total: 0,
        state: 10,
      },
      showDrawer: false,
      curItemDetail: {},
      dataColumn: [
        {
          title: "序号",
          fixed: "left",
          type: "index",
          align: "left",
          width: 80,
        },
        {
          title: "报告名称",
          key: "name",
          fixed: "left",
          align: "left",
          width: "140",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.name || "-");
          },
        },
        {
          title: "已读/未读",
          align: "left",
          width: "100",
          render: (h, params) => {
            const { state, isRead } = params.row;
            let text = "";
            if (state == 10) {
              text = "-";
            } else {
              text = isRead ? "已读" : "未读";
            }
            if (state == 10) {
              return h("div", text);
            } else {
              return h("div", { class: "u-flex" }, [
                h(
                  "div",
                  {
                    class: !isRead ? " errstatus" : "succstatus",
                  },
                  ""
                ),
                h(
                  "div",
                  { style: { "font-size": "12px", "margin-left": "5px" } },
                  text
                ),
              ]);
            }
          },
        },

        {
          title: "报告类型",
          // key: "identifierName",
          align: "left",
          width: "110",
          render: (h, params) => {
            let type = ["", "润滑点报告", "设备报告", "客户报告"];
            const item = params.row;
            return h("div", type[item.type] || "-");
          },
        },
        {
          title: "润滑点名称",
          key: "oilSiteName",
          align: "left",
          width: "200",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.oilSiteName || "-");
          },
        },
        {
          title: "润滑点装置",
          key: "describe",
          align: "left",
          width: "150",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.zhuangzhiName || "-");
          },
        },
        {
          title: "设备名称",
          key: "deviceName",
          align: "left",
          width: "150",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.deviceName || "-");
          },
        },
        {
          title: "设备类型",
          key: "deviceTypeName",
          align: "left",
          width: "180",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.deviceTypeName || "-");
          },
        },
        {
          title: "客户名称",
          key: "customerName",
          align: "left",
          width: "150",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.customerName || "-");
          },
        },
        {
          title: "客户行业",
          key: "customerIndustryName",
          align: "left",
          width: "150",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.customerIndustryName || "-");
          },
        },
        {
          title: "所在设备组",
          key: "workShopName",
          align: "left",
          width: "150",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.workShopName || "-");
          },
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          align: "left",
          width: "200",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtCreate || "-");
          },
        },

        {
          title: "发布状态",
          align: "left",
          width: "100",
          render: (h, params) => {
            const { state } = params.row;
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                },
              },
              [
                h("img", {
                  style: {
                    width: "14px",
                    height: "14px",
                    marginRight: "5px",
                  },

                  attrs: {
                    src: state == 10 ? water : suceess,
                  },
                }),
                h(
                  "div",
                  {
                    style: {
                      fontSize: "12px",
                    },
                  },
                  state == 10 ? "未发布" : "已发布"
                ),
              ]
            );
          },
        },
        {
          title: "发布时间",
          key: "issueNewestTime ",
          align: "left",
          width: "200",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.issueNewestTime || "-");
          },
        },
        //    {
        //   title: "发布时间",
        //   key: "issueNewestTime ",
        //    align:"center",
        //   width: "200",
        //   render: (h, params) => {
        //     const item = params.row;
        //     return h("div", item.issueNewestTime  );
        //   },
        // },
        {
          title: "创建人",
          key: "creatorName ",
          align: "left",
          width: "200",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.creatorName);
          },
        },

        {
          title: "操作",
          key: "address",
          align: "left",
          fixed: "right",
          width: 200,
          className: "action",
          render: (h, params) => {
            const item = params.row;
            let show0 = h(
              "div",
              {
                attrs: {
                  id: "config" + params.index,
                },
              },
              [
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                      display: this.bmaro(item.selfOrNot) ? "" : "none",
                    },
                    on: {
                      click: async () => {
                        this.$Modal.confirm({
                          title: `确定要发布吗？`,
                          onOk: async () => {
                            this.nvtodetl(item, "fabu");
                          },
                        });
                      },
                    },
                  },
                  "发布"
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                      display: this.bmaro(item.selfOrNot) ? "" : "none",
                    },
                  },
                  "|"
                ),

                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.nvtodetl(item);
                      },
                    },
                  },
                  "预览"
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                      // display: !this.bmaro ? "none" : ""
                      display: this.bmaro(item.selfOrNot) ? "" : "none",
                    },
                  },
                  "|"
                ),

                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      display: this.bmaro(item.selfOrNot) ? "" : "none",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.del(item);
                      },
                    },
                  },
                  "删除"
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                      display: item.canCancel == 0 ? "none" : "",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      display: item.canCancel == 0 ? "none" : "",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.nvtodetl(item);
                      },
                    },
                  },
                  "撤回"
                ),
              ]
            );
            let show1 = h(
              "div",
              {
                attrs: {
                  id: "config" + params.index,
                },
              },
              [
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        oilSiteModelread(item.id);
                        let downloadElement = document.createElement("a");
                        downloadElement.href = item.url;
                        document.body.appendChild(downloadElement);
                        downloadElement.click();
                        document.body.removeChild(downloadElement);
                      },
                    },
                  },
                  "下载"
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    class: "chakan",
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.nvtodetl(item);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                      display: item.canCancel == 0 ? "none" : "",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      display: item.canCancel == 0 ? "none" : "",
                      // marginRight: "10px"
                    },
                    on: {
                      click: async () => {
                        this.$Modal.confirm({
                          title: `确定撤回报告吗`,
                          onOk: async () => {
                            let data = await diagnosticcancel(item.id);
                            if (data.code == "00000") {
                              this.$Message.success("撤回成功");
                              this.getLists();
                            } else {
                              this.$Message.info(data.msg);
                            }
                          },
                        });
                      },
                    },
                  },
                  "撤回"
                ),
              ]
            );

            let show = item.state == 10 ? show0 : show1;
            if (this.userRole == "m3" || this.userRole == "m4") {
              show = [
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        oilSiteModelread(item.id);
                        let downloadElement = document.createElement("a");
                        downloadElement.href = item.url;
                        document.body.appendChild(downloadElement);
                        downloadElement.click();
                        document.body.removeChild(downloadElement);
                      },
                    },
                  },
                  "下载"
                ),
                  h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                    
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    class: "chakan",
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.nvtodetl(item);
                      },
                    },
                  },
                  "查看"
                ),
              ];
            }
            // if(item.canCancel==1){
            //   show.push()
            // }
            return show;
          },
        },
      ],
    };
  },
  created() {
    // 经销商
    // if (this.userRole.indexOf("a") > -1) {
    //     this.dataColumn.forEach((res, index) => {
    //         if (res.title === "操作") this.dataColumn.splice(index, 1);
    //     });
    // }
    if (["c0", "c1"].indexOf(this.userRole) > -1) {
      // 隐藏操作
      this.dataColumn = this.dataColumn
        .filter((col) => col.title != "客户名称")
        .filter((col) => col.title != "客户行业")
        .filter((col) => col.title != "发布状态")
        .filter((col) => col.title != "创建人");
    } else {
      this.$store.dispatch("listCollection", "consumer"); // 客户
      this.changeSel1();
    }
    this.$store.dispatch("listCollection", "consumerIndustry"); // 客户行业
    this.$store.dispatch("listCollection", "device"); // 设备
    this.$store.dispatch("listCollection", "deviceType"); // 设备类型
    this.$store.dispatch("listCollection", "workShop"); // 设备组
    // this.$store.dispatch("listCollection", "oilSiteType"); // 润滑点
    this.$store.dispatch("listCollection", "oilProduct"); // 润滑油油品
    this.$store.dispatch("dataCenter", "oilSiteLabel"); // 润滑油标签
    // this.$store.dispatch("dataCenter", "monitoringIndex"); // 监测指标
    this.$store.dispatch("listCollection", "oilSiteTypeIdentifier"); // 报警指标
  },
  mounted() {
    this.getLists();
    this.init();
  },
  methods: {
    async init() {
      let data1 = await olitypelist({
        current: 1,
        id: "",
        identifiers: [],
        name: "",
        size: 100,
      });

      this.cityList = data1.data.records.map((e) => {
        e.value = e.name;
        return e;
      });
    },
    tabinput(name) {
      this.tabName = name.string;

      this.pageInfo.state = name.string == "未发布" ? 10 : 20;
      this.getLists();

      this.$forceUpdate();
    },
    bmaro(value) {
      if (this.userRole.indexOf("m") > -1) {
        if (this.userRole == "m0" && !value) {
          return false;
        }
        return true;
      }
    },
    nameclear(e, anme) {
      this.dataForm[anme] = null;
      this.getLists();
    },

    async changeSel1(val, name) {
      let { data } = await ocmselect({
        size: 200,
        value: "",
        type: "consumer",
      });

      let namelist = data.records.map((ele) => ele.value);
      namelist = this.$c.ySegSort(namelist);
      this.namelist = namelist;
    },
    async del(item) {
      //
      this.$Modal.confirm({
        title: `您确定要删除该报告吗？`,
        content: `报告名称：${item.name}`,
        onOk: async () => {
          let data = await delpmentTree(item.id);
          if (data.code == "00000") {
            this.$Message.success("删除成功");
            this.getLists();
          } else {
            this.$Message.info(data.msg);
          }
        },
      });
    },
    nvtodetl1(item) {
      const routeUrl = this.$router.resolve({
        path: `/business/diaticreport?id=${item.id}`,
      });
      window.open(routeUrl.href, "_blank");
    },
    async nvtodetl(item, text = "look") {
      const { state, isRead, id } = item;

      if (text == "down") {
        var link = document.createElement("a");
        link.href = item.url;
        link.click();
        return false;
      }

      // 查看 预览 下载 =》已读
      // if (state == 20 && !isRead) {
      //   oilSiteModelread(id)
      // }
      if (text == "look") {
        oilSiteModelread(id);
      }

      ls.set("digitem", item);
      // const routeUrl = this.$router.resolve({
      //   path: `/business/diaticreport`,
      // });
      // return false;
      const routeUrl = this.$router.resolve({
        path: `/business/lookdiaticreport?id=${item.id}&text=${text}`,
      });
      window.open(routeUrl.href, "_blank");
    },
    timeChange(times) {
      times = times / 1000;

      let d = moment.duration(+times, "seconds");
      return (
        Math.floor(d.asDays()) +
        "天" +
        d.hours() +
        "时" +
        d.minutes() +
        "分" +
        d.seconds() +
        "秒"
      );
      return this.formatSeconds(times / 1000);
    },
    async getLists(page) {
      this.$store.state.spinShow = true;
      if (page) this.pageInfo.current = page; //分页处理
      let res = await equipmentTree({
        ...this.pageInfo,
        ...this.dataForm,
      });
      if (res.code === "00000") {
        const datas = res.data;
        this.dataLists = datas.records;

        this.pageInfo.total = datas.total;
        this.$store.state.spinShow = false;
      }
    },
    changeSize(data) {
      this.pageInfo.size = data;
      this.getLists();
    },
    searchInput(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeSel(val, name, arr = this.dataCenter) {
     

      if (name == "readInfo" && val) { 
       
        if (val === "1") {
          val = "已读";
        } else {
          val = "未读";
        }
      
      } else if (name == "state" && val) {
        if (val == 10) {
          val = "未发布";
        } else {
          val = "已发布";
        }
      }
      this.selItems = this.handleSelItem(val, name, arr);
      this.getLists(1);
    },
    changeDate(date, name) {
      if (date[0] != "" && date[1] != "") {
        this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      } else {
        this.selItems.forEach((item, index) => {
          if (item.name == name) {
            this.selItems.splice(index, 1);
          }
        });
      }
      this.dataForm.issusStartTime = date[0];
      this.dataForm.issusEndTime = date[1];
      this.getLists(1);
    },
    delSelItem(selItem, index) {
      // if (selItem.name == 'readInfo') {
      //   this.dataForm.state = null;
      // }
      // 报告类型
      this.dataForm[selItem.name] = "";
      if (selItem.name == "reportType") {
        this.dataForm.type = 0;
        delete this.dataForm.reportType;
      }
      //日期需要单独处理
      if (selItem.name === "gmtCreate") {
        delete this.dataForm.issusStartTime;
        delete this.dataForm.issusEndTime;
        this.dataForm.gmtCreate = "";
      }
      this.selItems.splice(index, 1);
      this.getLists(1);
    },
    addOil() {
      this.curItemDetail = {}; // 重置form
      this.showDrawer = true;
    },
    editDetail(item) {
      this.curItemDetail = deepcopy(item);
      this.showDrawer = true;
    },
    delItemWarning(item) {
      this.curItemDetail = deepcopy(item);
      this.$Modal.confirm({
        title: "确认删除" + item.name + " ?",
        onOk: () => {
          this.delItem();
        },
        onCancel: () => {},
      });
    },
    delItem() {
      api
        .axss("post", `/ocm-oil-site/oil-product/del/${this.curItemDetail.id}`)
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("删除成功");
            this.curItemDetail = {};
            this.getLists();
          }
        });
    },
    closeDrawer() {
      this.showDrawer = false;
      this.curItemDetail = {};
    },
    resetData() {
      this.reset("dataForm");
      this.getLists(1);
    },
    reset(key) {
      this.selItems = [];
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
};
</script>

<style lang='less' scoped>
.warning-recordlist {
  .lists {
    margin-top: 20px;
  }

  .common-search {
    li {
      flex: 0 0 273px;

      span {
        width: 93px;
      }
    }
  }
}
</style>